import { DS_POPOVER_PLACEMENTS, DSPopoverPlacement } from "../types/props";
import { Position } from "@/src/design_system/primitives/popover/types/position";

export const calculatePopoverCoordinates = ({
  activatorRect,
  contentRect,
  placement,
  offset,
}: {
  activatorRect: DOMRect;
  contentRect: DOMRect;
  placement: DSPopoverPlacement;
  offset: number;
}): Position => {
  const positionMap: Record<DSPopoverPlacement, () => Position> = {
    [DS_POPOVER_PLACEMENTS.BottomStart]: () => ({
      top: activatorRect.bottom + offset,
      left: activatorRect.left,
    }),
    [DS_POPOVER_PLACEMENTS.BottomEnd]: () => ({
      top: activatorRect.bottom + offset,
      left: activatorRect.right - contentRect.width,
    }),
    [DS_POPOVER_PLACEMENTS.TopStart]: () => ({
      top: activatorRect.top - contentRect.height - offset,
      left: activatorRect.left,
    }),
    [DS_POPOVER_PLACEMENTS.TopEnd]: () => ({
      top: activatorRect.top - contentRect.height - offset,
      left: activatorRect.right - contentRect.width,
    }),
    [DS_POPOVER_PLACEMENTS.RightStart]: () => ({
      top: activatorRect.top,
      left: activatorRect.right + offset,
    }),
    [DS_POPOVER_PLACEMENTS.LeftStart]: () => ({
      top: activatorRect.top,
      left: activatorRect.left - contentRect.width - offset,
    }),
  };

  return positionMap[placement]();
};

export const applyViewportConstraints = ({
  position,
  contentRect,
  viewportWidth,
  viewportHeight,
  padding,
}: {
  position: Position;
  contentRect: DOMRect;
  viewportWidth: number;
  viewportHeight: number;
  padding: number;
}): Position => {
  let { top, left } = position;

  // Horizontal constraints
  if (left < padding) {
    left = padding;
  } else if (left + contentRect.width > viewportWidth - padding) {
    left = viewportWidth - contentRect.width - padding;
  }

  // Vertical constraints
  if (top < padding) {
    top = padding;
  } else if (top + contentRect.height > viewportHeight - padding) {
    top = viewportHeight - contentRect.height - padding;
  }

  return { top, left };
};
